import { render, staticRenderFns } from "./RoomGarage.vue?vue&type=template&id=f8d2a016&scoped=true"
import script from "./RoomGarage.vue?vue&type=script&lang=ts"
export * from "./RoomGarage.vue?vue&type=script&lang=ts"
import style0 from "./RoomGarage.vue?vue&type=style&index=0&id=f8d2a016&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d2a016",
  null
  
)

export default component.exports